import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCockroachlabsComponent } from './simple-icons-cockroachlabs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCockroachlabsComponent ],
    exports:      [ SimpleIconsCockroachlabsComponent ],
    bootstrap:    []
})
export class SimpleIconsCockroachlabsModule {}
